import PipelineCommissionFeeEditorContainer from './containers/PipelineCommissionFeeEditorContainer'

export default PipelineCommissionFeeEditorContainer
